import React from "react";
import { createRoot } from "@wordpress/element";
import ReferralComponent from "./referral-component";

// Initialize all referral blocks on the page
document.addEventListener("DOMContentLoaded", () => {
	const blocks = document.querySelectorAll(".wp-block-leat-referral");

	blocks.forEach((block) => {
		const blockElement = block as HTMLElement;

		// Extract all data from attributes
		const referralData = {
			referralCode: blockElement.dataset.referralCode || "",
			referredContacts: Number.parseInt(blockElement.dataset.referredContacts || "0", 10),
			completedReferrals: Number.parseInt(blockElement.dataset.completedReferrals || "0", 10),
			homeUrl: blockElement.dataset.homeUrl || "",
			ajaxUrl: "/wp-admin/admin-ajax.php",
			restUrl: "/wp-json/leat/v1",
			nonce: "", // Not needed for display
		};

		const showShareButton = blockElement.dataset.showShareButton !== "false";
		const buttonColor = blockElement.dataset.buttonColor || "";
		const buttonTextColor = blockElement.dataset.buttonTextColor || "";

		// Create a root and render the component
		const root = createRoot(blockElement);
		root.render(
			<ReferralComponent
				showShareButton={showShareButton}
				buttonColor={buttonColor}
				buttonTextColor={buttonTextColor}
				referralData={referralData}
			/>
		);
	});
});
